<template>
  <!-- 音量 -->
  <div
    style="position: relative"
    ref="volume"
    @mouseenter="volume_mouseenter_handler"
    @mouseleave="volume_mouseleave_handler"
  >
    <div class="icon" style="position:relative" @click="volume_click_handler">
      <i-volume
        v-show="!is_off_volume"
        :color="is_show_volume ? hight_color : 'white'"
      ></i-volume>
      <i-volume-off
        v-show="is_off_volume"
        :color="is_show_volume ? hight_color : 'white'"
      ></i-volume-off>
    </div>

    <div
      style="position: absolute;top:-135px;padding-bottom: 10px;left:50%;transform: translateX(-60%);"
    >
      <div
        v-show="is_show_volume"
        style="padding: 10px 10px 15px;background: rgb(57,57,57);"
      >
        <el-slider
          @input="volume_handler"
          v-model="volume"
          vertical
          height="100px"
        >
        </el-slider>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "volume",
  props:{
    hight_color:{
      type: String,
      default: "#de8817"
    },
    player:{
      type: Object,
      default: ()=>({})
    },
    sessionId:{
      type: Number | String
    },
    eventId:{
      type: Number | String
    }
  },
  data(){
    return {
      volume: 50,
      is_show_volume: false,
      is_off_volume: false,
    }
  },
  methods: {
    // 调节音量
    volume_handler() {
      // console.log(this.player);
      this.$nextTick(() => {
        if (this.player.setVolume) {
          this.player.setVolume(this.volume / 100);
          if (this.volume <= 0) {
            this.is_off_volume = true;
          } else {
            this.is_off_volume = false;
          }
        }
      });
    },
    volume_click_handler() {
      if (this.player.setVolume) {
        this.is_off_volume = !this.is_off_volume;
        if (this.is_off_volume) {
          this.player.setVolume(0);
          this.volume = 0;
          this.$util.add_action_log("volume", {
            action: "off",
            sessionId: this.sessionId,
            eventId: this.eventId
          });
        } else {
          this.player.setVolume(0.5);
          this.volume = 50;
          this.$util.add_action_log("volume", {
            action: "on(half)",
            sessionId: this.sessionId,
            eventId: this.eventId
          });
        }
      }
    },
    // 鼠标移入
    volume_mouseenter_handler() {
      this.is_show_volume = true;
      this.$emit("mouseenter")
    },
    // 鼠标移出
    volume_mouseleave_handler() {
      this.is_show_volume = false;
      this.$emit("mouseleave")
    }
  }
};
</script>

<style scoped lang="less">
.icon{
  &:hover{
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/player_control/volume.vue